import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeletePollResponseBody } from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { pollQueryKeyFactory } from './usePollQuery';
import { pollsQueryKeyFactory } from './usePollsQuery';

export type IUseDeletePollMutationValues = {
  appId: string;
  pollId: string;
};

export const useDeletePollMutation = (): UseMutationResult<
  IApiDeletePollResponseBody,
  unknown,
  IUseDeletePollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeletePollMutationValues) =>
      api.polls.delete(values.appId, values.pollId),
    onSuccess: async (_, values) => {
      [
        // TODO once the API is updated to return the deleted resources
        // data.deletedResources.pollIds
        values.pollId,
      ]
        .map((streamId) => [
          {
            queryKey: pollQueryKeyFactory({
              appId: values.appId,
              pollId: streamId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: pollsQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
